import React, { useRef, useState } from 'react'
import { 
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogTitle, 
    Grid, 
    makeStyles, 
    Paper, 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    FormControlLabel,
    Switch
} from '@material-ui/core'
import { AutorizacionesModalItem } from './AutorizacionesModalItem';

const useStyles = makeStyles({
    root: {
      flexGrow: 1,
      margin: 5,
    },
    button: {
        margin: 5
    },
    rootTable: {
        "& > *": {
        borderBottom: "unset",
        },
    },
});

export const AutorizacionesModalSolicitudesPendientes = (props) => {
    const classes = useStyles();
    
    const { items } = props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(4);
    const [dense, setDense] = useState(false);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 8));
        setPage(0);
    };

    const componentRef = useRef();
    
    return (
        <>
            <Dialog
                fullWidth
                maxWidth="lg"
                open={props.open}
                onClose={props.closeModalHandler}
            >
                <DialogTitle>Solicitudes Pendientes</DialogTitle>
                <DialogContent>
                    <TableContainer component={Paper} style={{ overflowX: "auto" }}>
                        <Table size={dense ? "small" : "medium"} ref={componentRef}>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Estado</TableCell>
                                    <TableCell align="left">Fecha Carga</TableCell>
                                    <TableCell align="left">N° Orden</TableCell>
                                    <TableCell align="left">Tipo Solicitud</TableCell>
                                    <TableCell align="left">Con Internación</TableCell>
                                    <TableCell align="left">Diagnostico</TableCell>
                                    <TableCell align="left">Practicas</TableCell>
                                    <TableCell align="left">Paciente</TableCell>
                                    <TableCell align="left">N° Afiliado</TableCell>
                                    <TableCell align="left">Seccional</TableCell>
                                    <TableCell align="left">Tomada</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.length > 0 ? (
                                    items
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item) => (
                                        <AutorizacionesModalItem 
                                            item={item}
                                            expandirPracticas={false}
                                            key={item.idSolicitud?.toString()}
                                        />
                                    ))
                                ) : (
                                    <TableRow style={{ height: 50 }}>
                                        <TableCell
                                            colSpan={13}
                                            style={{ textAlign: "-webkit-center" }}
                                        >
                                            {" "}
                                            Sin Registros
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                {items.length > 0 && (
                    <Grid container xs={12}>
                        <Grid item xs={4}>
                            <FormControlLabel
                                control={
                                    <Switch
                                    checked={dense}
                                    onChange={(e) => setDense(e.target.checked)}
                                    />
                                }
                                label="Tamaño compacto"
                                className={classes.root}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <TablePagination
                                style={{ backgroundColor: "white" }}
                                rowsPerPageOptions={[4, 8, 20]}
                                component="div"
                                count={items.length}
                                rowsPerPage={rowsPerPage}
                                labelRowsPerPage="Registros por página"
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Grid>
                    </Grid>
                )}
                <DialogActions className={classes.root}>
                    <Button 
                        className={classes.button}
                        variant="contained"
                        color="secondary"
                        onClick={props.closeModalHandler} 
                        >
                        Cancelar
                    </Button>
                    <Button 
                        className={classes.button}
                        variant="contained"
                        color="primary"
                        autoFocus
                        type="submit" 
                        onClick={props.onSubmitHandler}
                    >
                        Continuar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}